async function retryFunction<T>(
	fn: (...args: unknown[]) => T | Promise<T>,
	delayInMs: number,
	retries?: number,
): Promise<T> {
	try {
		const val = await fn();
		return val;
	} catch (error) {
		console.error(error);
		if (retries === 0) {
			throw error;
		}
		await new Promise((res) => setTimeout(res, delayInMs));
		return await retryFunction(fn, delayInMs, retries ? retries - 1 : undefined);
	}
}

export type RetryPromise<T> = Promise<T>;

export type RetryOptions = {
	delayInMs?: number;
	maxRetries?: number;
};

/**
 *
 * @param fn
 * @param options
 * @param options.delayInMs defaults to 500 ms
 * @param options.maxRetries
 * @returns
 */
export function retry<T>(fn: (...args: unknown[]) => T | Promise<T>, options?: RetryOptions): RetryPromise<T> {
	return retryFunction(fn, options?.delayInMs ?? 500, options?.maxRetries);
}

export function sleep(ms: number): Promise<void> {
	return new Promise((resolve) => {
		setTimeout(resolve, ms);
	});
}
